<template>
  <footer class="w-full border-t-2 border-gray-300 py-8 dark:border-gray-800">
    <div class="mx-auto flex max-w-4xl flex-col items-center justify-center space-y-1 text-sm font-bold text-gray-700 dark:text-gray-400 sm:flex-row sm:justify-start sm:space-y-0 sm:space-x-2">
      <slot></slot>
    </div>
  </footer>
</template>
